import { defineStore } from 'pinia'
import { useSecurityStore } from '~/stores/securityStore'
import { ref } from 'vue'

export const useAuthStore = defineStore('authStore', () => {
  const token = ref('')
  const sessionId = ref('')
  const jwtPromise = ref<Promise<void> | null>(null)
  const securityStore = useSecurityStore();


  const generateJwt = async () => {
    if (sessionId.value) return

    if (jwtPromise.value) {
      return jwtPromise.value
    }
    if (!securityStore.data?.csrf) {
        await securityStore.fetch();
    }
    const csrf = securityStore.data?.csrf;

    if (!csrf) {
        return Promise.reject("Invalid CSRF token/data.");
    }


    jwtPromise.value = (async () => {
      const response = await useNuxtApp().$siteFetch<{
        token: string
        sessionId: string
      }>('/phe/jwt/generate', {
        method: 'POST',
        headers: {
          [csrf.headerName]: csrf.token
        },
      })

      if (!response?.token || !response?.sessionId) {
        throw new Error('Invalid JWT response')
      }

      token.value = response.token
      sessionId.value = response.sessionId
    })()

    try {
      await jwtPromise.value
    } finally {
      jwtPromise.value = null
    }
  }

  const ensureSession = async () => {
    if (!sessionId.value) {
      await generateJwt()
    }
  }

  return {
    token,
    sessionId,
    ensureSession
  }
})